module.exports = "/assets/a6c729646b7b21f87290827d141b2482.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/v2-icons/euro.svg
// module id = 3324
// module chunks = 0